import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

const state = {
  debug: {
    init: 0,
    menu: {}
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
